import type { SourcesFilters } from "@/types";
import { EMPTY_SOURCES_FILTERS, RECENT_DAYS } from "@/utils/sourcesFilters.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export interface SourcesPreset {
  readonly label: string;
  readonly filters: Partial<SourcesFilters>;
  readonly needsYourProduct: boolean;
}

export const SOURCES_PRESETS: readonly SourcesPreset[] = [
  { label: copy.PRESET_YOUR_PRODUCT, filters: { yourProduct: true }, needsYourProduct: true },
  { label: copy.PRESET_SECRET_FILES, filters: { groups: ["secretFiles"] }, needsYourProduct: false },
  { label: copy.PRESET_FAILED, filters: { furthestSteps: ["failed"] }, needsYourProduct: false },
  { label: copy.PRESET_NO_ATTEMPT, filters: { furthestSteps: ["reachedNoAttempt"] }, needsYourProduct: false },
  { label: copy.PRESET_KNOWN_SCANNERS, filters: { who: ["researchScanner"] }, needsYourProduct: false },
  { label: copy.PRESET_NEW, filters: { firstSeenDays: RECENT_DAYS }, needsYourProduct: false },
];

type FilterKey = keyof SourcesFilters;

function isSameValue(a: unknown, b: unknown): boolean {
  if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every((value) => b.includes(value));
  return a === b;
}

function presetKeys(preset: SourcesPreset): FilterKey[] {
  return Object.keys(preset.filters) as FilterKey[];
}

export function applyPreset(current: SourcesFilters, preset: SourcesPreset): SourcesFilters {
  return { ...current, ...preset.filters };
}

export function isPresetActive(current: SourcesFilters, preset: SourcesPreset): boolean {
  return presetKeys(preset).every((key) => isSameValue(current[key], preset.filters[key]));
}

export function resetPreset(current: SourcesFilters, preset: SourcesPreset): SourcesFilters {
  const reset = Object.fromEntries(presetKeys(preset).map((key) => [key, EMPTY_SOURCES_FILTERS[key]]));
  return { ...current, ...reset };
}
